var map = {
  "./ConfirmQuote/index": "8454",
  "./Making/XiaoHao/index": "80467",
  "./Making/index": "80530",
  "./PendingQuote/index": "21114",
  "./RequotePrice/index": "14398",
  "./SettledUpload/index": "33089",
  "./SupplierSubmissionKol/index": "65686"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54673;
